import { GBTypography } from '@leapfinance/geebee-component-library';
import classNames from 'classnames';
import React from 'react';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
var TabButton = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, hideArrow = _a.hideArrow, onClick = _a.onClick;
    return (React.createElement("div", { className: "lfc-cursor-pointer lfc-flex lfc-flex-col lfc-gap-0 lfc-border lfc-border-gbTokens-grey-A300  lfc-rounded lfc-p-2", onClick: onClick },
        React.createElement("div", { className: classNames('lfc-flex lfc-items-center', {
                'lfc-justify-between': !hideArrow,
                'lfc-justify-center': hideArrow
            }) },
            typeof title === 'string' ? (React.createElement(GBTypography, { variant: "sh2Semibold", className: "lfc-text-black" }, title)) : (title),
            !hideArrow && React.createElement(ArrowForwardRoundedIcon, { className: "lfc-text-gbTokens-primary-500" })),
        typeof subtitle === 'string' ? (React.createElement(GBTypography, { variant: "caption2Semibold", className: "lfc-text-gbTokens-grey-A900" }, subtitle)) : (subtitle)));
};
export default TabButton;
//# sourceMappingURL=TabButton.js.map